var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('div',{staticClass:"sticky-top"},[_c('BaseLogoBar'),_c('BaseNavbar'),_c('div',[_c('BreadCrumb')],1)],1),_c('div',{staticClass:"d-flex",attrs:{"id":"wrapper"}},[_c('div',{attrs:{"id":"page-content-wrapper"}},[_c('div',{},[_c('router-view')],1)])]),_c('BaseFooter')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }